<template>
  <div class="my-list">
    <!-- 搜索 -->
    <div v-if="props.search.length" class="searchDiv">
      <my-form ref="searchformRef" :form="props.search" @submit="search" @keyup.enter="searchformRef?.submitLoading?'':searchformRef.submit()" layout="inline" :hideLable="true">
        <template #default="{ item, form }">
          <slot name="search" :item="item" :form="form" :runAction="runAction" :isActionLoading="isActionLoading"></slot>
        </template>
        <template #footer>
          <div></div>
        </template>
      </my-form>
      <div style="white-space: nowrap;">
        <my-button type="search" @click="submitSearchForm" :loading="searchformRef?.submitLoading"></my-button>
        <my-button type="rest" @click="resetSearchForm" style="margin-right: 0;"></my-button>
      </div>
    </div>
    <div class="tableDiv">
      <!-- 新增 批量删除 导出 导入 等 -->
      <div class="topBtn">
        <my-button type="add" v-if="$route.meta[`${getModule}add`]&&props.api.save" @click="props.api.addFun ? props.api.addFun({ callback: addRouteQuery }) : addRouteQuery()">{{ props.api.addButtonLabel || '新增'}}</my-button>
        <my-button type="import" v-if="$route.meta[`${getModule}import`]&&props.api.import" @click="visibleImport = true"></my-button>
        <slot name="topBtn" :selectedRowKeys="selectedRowKeys" :selectedRows="selectedRows" :runAction="runAction" :isActionLoading="isActionLoading"></slot>
        <my-button type="export" v-if="$route.meta[`${getModule}export`]&&props.api.export" @click="exportFun"></my-button>
        <!-- <my-button type="delete" v-if="$route.meta[`${getModule}delete`]&&props.api.batchDelete" :disabled="!selectedRowKeys.length" @click="deleteFun()"></my-button> -->
        <span v-if="showColumn && showColumn.length" class="column-setting">
          <a-popover trigger="hover" placement="bottomRight">
            <template #content>
              <div class="column-list" v-for="(item, i) in showColumn" :key="item.key ?? 'showColumn'+i" @mouseenter="item.showAction = true;" @mouseleave="item.showAction = false;">
                <a-checkbox v-model:checked="item.show">{{ item.title }}</a-checkbox>
                <div class="action-div">
                  <UpOutlined v-show="item.showAction" class="action-btn" :class="!i ? 'disabled' : ''" @click="sortColumnAction(item, i, true)" />
                  <DownOutlined v-show="item.showAction" class="action-btn" :class="i === showColumn.length - 1 ? 'disabled' : ''" @click="sortColumnAction(item, i, false)" />
                </div>
              </div>
            </template>
            <a-button><eye-outlined /></a-button>
          </a-popover>
        </span>
      </div>
      <div class="tableDivCenter">
        <slot name="tableLeft" :runAction="runAction" :isActionLoading="isActionLoading"></slot>
        <slot name="content" :runAction="runAction" :isActionLoading="isActionLoading">
          <!-- 表格 -->
          <a-config-provider :component-size="componentSize" :locale="zhCN">
            <a-table v-if="props.api && props.api.page"
                     :dataSource="dataSource.length?dataSource:props.dataSource"
                     :columns="columns.filter(v=>v.show)"
                     :pagination="hasPagination ? pagination : false"
                     :row-selection="$attrs.rowSelection === false ? null : { preserveSelectedRowKeys: true, selectedRowKeys: selectedRowKeys, onChange: onSelectRow, onSelect: rowSelect, hideSelectAll: $attrs.rowSelectRadio, ...($attrs.rowSelection || {}) }"
                     :rowKey="props.rowKey"
                     :scroll="{ x: '100%', y: `calc(100vh - 425px)` }"
                     :loading="tableLoading"
                     @resizeColumn="(width, col) => col.width = width"
                     style="width: 100%;"
                     v-bind="tableConfig">
              <template #bodyCell="{ column, record, index }">
                <template v-if="column.key === 'index' || column.dataIndex === 'index'">
                  <span>
                    {{ (pagination.current - 1) * pagination.pageSize +  index + 1 }}
                  </span>
                </template>
                <template v-else-if="column.type === 'img'">
                  <a-image-preview-group v-if="record[column.key || column.dataIndex]">
                    <template v-if="typeof(record[column.key || column.dataIndex])=='string'&&!column.setImgs">
                      <a-image :width="60" :src="record[column.key || column.dataIndex]" style="object-fit:cover;" />
                    </template>
                    <template v-else>
                      <div style="height:60px;width:60px;">
                        <a-image v-for="(img, imgIndex) in column.setImgs ? column.setImgs(record[column.key || column.dataIndex]) : record[column.key || column.dataIndex]" :width="60" :height="60" :src="img" />
                      </div>
                    </template>
                  </a-image-preview-group>
                </template>
                <template v-else-if="column.type === 'time' || column.type === 'timeHMS'">
                  {{ dateFormat(record[column.key || column.dataIndex], column.type === 'timeHMS' ? 'YYYY/MM/DD HH:mm' : column.format) }}
                </template>
                <template v-else-if="column.type === 'empty'">
                  {{ record[column.key || column.dataIndex] || column.default || '- -' }}
                </template>
                <template v-else-if="column.type === 'amount'">
                  {{ formatAmount(record[column.key || column.dataIndex], column.default || '- -') }}
                </template>
                <template v-else-if="column.key === 'action' || column.dataIndex === 'action'">
                  <div style="white-space: nowrap;">
                    <my-button type="link" v-if="props.api.pageByID&&(!props.api.hidePreview || props.api.hidePreview(record) !== true)" @click="addRouteQuery({ type: 'preview', data: record })" size="small">查看</my-button>
                    <my-button type="link"
                               v-if="$route.meta[`${getModule}update`]&&props.api.update"
                               :disabled="props.api.hideUpdate && props.api.hideUpdate(record) === true"
                               @click="addRouteQuery({ type: 'update', data: record })"
                               size="small">{{ props.api.updateButtonLabel || '编辑'}}</my-button>
                    <my-button type="link" v-if="$route.meta[`${getModule}approval`]&&props.api.approval && (!props.api.hideApproval || props.api.hideApproval(record) !== true)" @click="addRouteQuery({ type: 'approval', data: record })" size="small">审批</my-button>
                    <slot name="action" :column="column" :record="record" :index="index" :runAction="runAction" :isActionLoading="isActionLoading"></slot>
                    <my-button type="link"
                               v-if="$route.meta[`${getModule}delete`]&&props.api.batchDelete"
                               :disabled="props.api.hideDelete && props.api.hideDelete(record) === true"
                               @click="deleteFun(record)"
                               size="small"
                               danger>{{ props.api.deleteButtonLabel || '删除'}}</my-button>
                  </div>
                </template>
                <slot name="table" :column="column" :record="record" :index="index" :runAction="runAction" :isActionLoading="isActionLoading"></slot>
              </template>
              <template #footer v-if="$slots.tableFooter">
                <slot name="tableFooter" :runAction="runAction" :isActionLoading="isActionLoading"></slot>
              </template>
              <!--        <template #expandIcon="{ expanded, onExpand, record }">-->
              <!--          <div class="ant-table-row-expand-icon">-->
              <!--            <DownOutlined v-if="expanded" />-->
              <!--            <RightOutlined v-else />-->
              <!--          </div>-->
              <!--        </template>-->
            </a-table>
          </a-config-provider>
        </slot>
      </div>
    </div>
    <!-- 表单 -->
    <component :is="{ drawer: 'my-drawer', modal: 'my-modal', page: 'my-page-modal' }[props.modalType] || 'my-modal'"
               :title="`${$route.meta.title} ${FormTitle}`"
               v-model="visibleForm"
               :bodyStyle="{ paddingRight: '58px' }"
               :width="modalWidth"
               @cancel="formClose"
               @close="formClose">
      <a-spin :spinning="spinningForm" tip="加载中...">
        <my-form ref="formRef" :form="form" @submit="submit" :show="visibleForm" :showSubmit="false" :whiteList="false" :openType="openType" :title="FormTitle" :width="modalWidth" :formStyle="formStyle" :labelWidth="$attrs.labelWidth" :form-tab-names="$attrs.formTabNames">
          <template #default="{ item, form, show, disabled, openType }">
            <slot name="form" :item="item" :form="form" :show="show" :disabled="disabled" :openType="openType" :runAction="runAction" :isActionLoading="isActionLoading"></slot>
          </template>
        </my-form>
      </a-spin>
      <template #footer>
        <my-button v-if="openType!='preview' && !props.api.hideSubmitBtn" @click="formRef.submit({})" :loading="formRef?.submitLoading">提交</my-button>
        <my-button v-if="props.api.draft && (openType=='add' || (openType=='update' && formRef?.formList?.auditStatus == 3))" @click="formRef.submit(true, false)" :loading="formRef?.submitLoading">保存</my-button>
<!--        <my-button v-if="openType!='preview' && openType!='approval' && openType!='update'" type="rest" @click="formRef.resetData();formRef.clearValidate()"></my-button>-->
      </template>
      <template #right>
        <slot name="modalRight" :form="formRef?.formList || {}" :show="visibleForm" :openType="openType" :runAction="runAction" :isActionLoading="isActionLoading"></slot>
      </template>
    </component>
    <!-- 导出 -->
    <my-modal title="导出" v-model="visibleExport" :bodyStyle="{ paddingRight: '58px' }" :width="700">
      <my-form v-if="props.export.length" ref="exportFormRef" :form="props.export" @submit="exportFun">
        <template #default="{ item, form, show, disabled }">
          <slot name="export" :item="item" :form="form" :show="show" :disabled="disabled" :runAction="runAction" :isActionLoading="isActionLoading"></slot>
        </template>
        <template #footer>
          <span></span>
        </template>
      </my-form>
      <template #footer>
        <my-button :loading="exportFormRef?.submitLoading" @click="exportFormRef.submit(true)">确定导出</my-button>
        <my-button @click="visibleExport = false;exportFormRef.resetData();exportFormRef.clearValidate()">取消</my-button>
      </template>
    </my-modal>
    <!-- 导入 -->
    <my-modal :title="importTitle" v-model="visibleImport" :bodyStyle="{ paddingRight: '58px' }" width="80%">
      <a-spin :spinning="spinningImport" tip="加载中...">
        <div style="padding-bottom: 20px;">
          <input ref="importFile" type="file" style="display:none;" @change="importPreview" accept=".xls,.xlsx"/>
          <my-button @click="$refs.importFile.click()">选择导入文件</my-button>
          <a-button
            v-if="props.api.importTemplate"
            type="link"
            :loading="downloadingImportTemplate"
            style="margin-left: 12px;"
            @click="downloadImportTemplate"
          >
            下载{{ props.api.importTemplateName }}模板
          </a-button>
        </div>
        <div class="formItemTitle">
          <div class="columnIcon"></div>
          可导入数据
        </div>
        <a-table :dataSource="importData.successList || []"
                 :columns="importSuccessColumns"
                 rowKey="index"
                 :scroll="{ x: '100%', y: `calc(100vh - 500px)` }"
                 style="width: 100%;"></a-table>
        <div class="formItemTitle">
          <div class="columnIcon"></div>
          异常数据
        </div>
        <a-table :dataSource="importData.errorList || []"
                 :columns="importErrorColumns"
                 rowKey="index"
                 :scroll="{ x: '100%', y: `calc(100vh - 500px)` }"
                 style="width: 100%;"></a-table>
      </a-spin>
      <template #footer>
        <my-button :loading="importLoading" @click="importFun()">确定导入</my-button>
      </template>
    </my-modal>
  </div>
</template>

<script>
  import myPageModal from '../my-page-modal/index.vue';
  // declare additional options
  export default {
    inheritAttrs: false,
    components: {
      myPageModal
    }
  }
</script>
<script setup>
  import { ref, reactive, onMounted, onUnmounted, defineProps, defineExpose, defineEmits, watchEffect, watch, isReactive, nextTick, computed, useAttrs, triggerRef } from 'vue';
  import { message, Modal } from 'ant-design-vue';
  import { EyeOutlined, DownOutlined, UpOutlined } from "@ant-design/icons-vue";
  import { dateFormat, formatAmount } from '@/utils';
  import zhCN from 'ant-design-vue/es/locale/zh_CN';
  import { useRouter, useRoute } from 'vue-router';

  const router = useRouter();
  const route = useRoute();

  const props = defineProps({
    search: {
      type: Array,
      default: () => []
    },
    form: {
      type: Array,
      default: () => []
    },
    previewForm: {
      type: Array,
    },
    approvalForm: {
      type: Array,
    },
    export: {
      type: Array,
      default: () => []
    },
    dataSource: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    importColumns: {
      type: Array,
      default: () => []
    },
    importErrorColumns: {
      type: Array,
      default: () => []
    },
    api: {
      type: Object,
      default: () => ({})
    },
    tableConfig: {
      type: Object,
      default: () => ({})
    },
    rowKey: {
      type: [String],
      default: 'id'
    },
    modalWidth: {
      type: [Number, String],
    },
    modalType: {
      type: [String],
      default: 'page'
    },
    target: {
      type: [String],
      default: ''
    },
    setUrlParam: {
      type: [Function],
    },
    onBeforeFormInit: {
      type: Function,
      default: () => Promise.resolve()
    },//打开表单前
    onBeforeSubmit: {
      type: Function,
      default: () => Promise.resolve()
    },//提交表单前
    onSearchSubmit: {
      type: Function,
      default: () => Promise.resolve()
    },//点击搜索按钮时同步触发
    onSearchReset: {
      type: Function,
      default: () => Promise.resolve()
    },//点击搜索重置按钮时同步触发
    onAfterSubmit: {
      type: Function,
    },//提交表单前
    onBeforeFormClose: {
      type: Function,
      default: () => Promise.resolve()
    },//关闭表单前
    onSubmitError: {
      type: Function,
      default: () => Promise.resolve()
    },//关闭表单前
    //处理search返回数据
    changeSearchData:{
      type: Function,
    },
  });

  const emits = defineEmits(['init', 'afterFormInit', 'formInit', 'afterSubmit', 'afterSearch']);

  const attrs = useAttrs();

  const getModule = computed(() => props.api.module ? `${props.api.module}_` : '');

  // storage key prefix to avoid ambiguity between different usages
  const COLUMN_STORAGE_PREFIX = 'myList.columns.';
  const getStorageKey = (name) => `${COLUMN_STORAGE_PREFIX}${name}`;

  //查询和表单ref对象
  const searchformRef = ref();
  const formRef = ref();
  const submitSearchForm = () => {
    try {
      Promise.resolve(props.onSearchSubmit(searchformRef.value?.formList || {})).catch(error => {
        message.error(error?.msg || '搜索联动处理失败');
      });
    } catch (error) {
      message.error(error?.msg || '搜索联动处理失败');
    }
    searchformRef.value?.submit({ checkDateIsChange: false });
  };

  const resetSearchForm = () => {
    searchformRef.value?.resetData();
    try {
      Promise.resolve(props.onSearchReset(searchformRef.value?.formList || {})).catch(error => {
        message.error(error?.msg || '重置联动处理失败');
      });
    } catch (error) {
      message.error(error?.msg || '重置联动处理失败');
    }
    searchformRef.value?.submit({ checkDateIsChange: false });
  };

  const componentSize = ref('middle');
  const resizeFun = () => componentSize.value = window.innerWidth > 1600 ? 'middle' : 'small';

  const pageName = ref(route.name);
  //初始化方法
  onMounted(() => {
    resizeFun();
    window.addEventListener('resize', resizeFun);
    if (searchformRef.value) {
      searchformRef.value.initData(searchformRef.value?.formList);
    }
    search({});
    setColumnSort();
  });
  //销毁事件
  onUnmounted(() => {
    window.removeEventListener('resize', resizeFun);
  });

  //表头数据
  const columns = ref([]);
  const importSuccessColumns = ref([]);
  const importErrorColumns = ref([]);
  const applyingStored = ref(false);
  watchEffect(() => {
    columns.value = props.columns.map(column => Object.assign({ ellipsis: true, width: 150, minWidth: 100, show: true, resizable: true, align: 'center' }, column));
    if (props.importColumns.length) {
      importSuccessColumns.value = [...props.importColumns];
      importErrorColumns.value = [...props.importColumns, { title: '异常原因', dataIndex: 'errorMessage', key: 'errorMessage', ellipsis: true, width: 250 }];
    }
    if (props.importErrorColumns.length) {
      importErrorColumns.value = [...props.importErrorColumns];
    }
    if (props.api.import && !props.importErrorColumns.length && !props.importColumns.length) {
      importSuccessColumns.value = props.columns.map(column => Object.assign({ ellipsis: true, width: 150, show: true }, column));
      importErrorColumns.value = [...importSuccessColumns.value, { title: '异常原因', dataIndex: 'errorMessage', key: 'errorMessage', ellipsis: true, width: 250 }];
    }
    if (props.columns[0] && props.columns[0].key == 'index') {//如果第一列是index 给默认宽度
      !props.columns[0].width && (columns.value[0].width = 80);
      columns.value[0].fixed = 'left';
    }
    const last = props.columns[props.columns.length - 1];
    if (last && last.key == 'action') {//如果最后一列是操作栏 给默认宽度
      columns.value[columns.value.length - 1].width = last.width || 200;
      columns.value[columns.value.length - 1].fixed = 'right';
      columns.value[columns.value.length - 1].ellipsis = false;
    }
  });

  const showColumn = computed(() => columns.value.filter(v => v.key !== 'action' && v.key !== 'index'));

  const sortColumnAction = (item, index, isUpper) => {
    const visible = showColumn.value;
    if (!visible || !visible.length) return;
    if (isUpper && index === 0) return;
    if (!isUpper && index === visible.length - 1) return;
    const newIndex = isUpper ? index - 1 : index + 1;
    const keyA = visible[index]?.key;
    const keyB = visible[newIndex]?.key;
    if (!keyA || !keyB) return;
    const idxA = columns.value.findIndex(c => c.key === keyA);
    const idxB = columns.value.findIndex(c => c.key === keyB);
    if (idxA === -1 || idxB === -1) return;
    [columns.value[idxA], columns.value[idxB]] = [columns.value[idxB], columns.value[idxA]];
    saveColumnState();
  }

  /**
   * 保存列的顺序和显隐到 localStorage，key 使用 route.name
   */
  const saveColumnState = () => {
    try {
      const order = showColumn.value.map(item => item.key);
      const visibility = {};
      columns.value.forEach(col => {
        visibility[col.key] = col.show;
      });
      const payload = { order, visibility };
      localStorage.setItem(getStorageKey(route.name), JSON.stringify(payload));
    } catch (e) {
      console.error('saveColumnState error', e);
    }
  }

  const setColumnSort = () => {
    // prefer new prefixed key but fallback to old key for compatibility
    const prefKey = getStorageKey(route.name);
    let keysStr = localStorage.getItem(prefKey);
    if (!keysStr) {
      return;
    }
    let payload = null;
    try {
      payload = JSON.parse(keysStr);
    } catch (e) {
      // backward compatibility: if the stored value is comma separated keys
      payload = { order: (keysStr || '').split(',') };
    }
    const keys = (payload && payload.order) || [];
    if (!keys.length) {
      return;
    }
    applyingStored.value = true;
    // 如果包含 visibility 信息，先应用显隐
    if (payload && payload.visibility) {
      columns.value.forEach(col => {
        // keep index/action columns fixed (don't change visibility from storage)
        if (col.key === 'index' || col.key === 'action') return;
        if (Object.prototype.hasOwnProperty.call(payload.visibility, col.key)) {
          col.show = payload.visibility[col.key];
        }
      });
    }
    const temp = sortHeadersByKeys(columns.value, keys);
    temp.forEach((item, index) => {
      columns.value[index] = item;
    });
    // allow watchers to settle before turning off flag
    setTimeout(() => { applyingStored.value = false; }, 0);
  }

  // 当列配置发生变化（例如通过复选框修改显隐）时保存状态，避免在应用存储状态时触发保存
  watch(columns, () => {
    if (!applyingStored.value) {
      saveColumnState();
    }
  }, { deep: true });

  /**
   * 根据 key 数组顺序重新排列表头数据
   * @param {Array} headers - 表头数据数组，每个元素是一个对象，包含 key 和其他属性
   * @param {Array} keys - 用于排序的 key 数组
   * @returns {Array} 重新排序后的表头数据
   */
  function sortHeadersByKeys(headers, keys) {
    // 将未在 keys 中的列放回它们原始索引位置，
    // 然后按 keys 的顺序把匹配到的列填入剩余位置。
    if (!Array.isArray(headers) || !Array.isArray(keys)) return headers;
    const n = headers.length;
    const headerMap = new Map();
    headers.forEach((h, idx) => headerMap.set(h.key, { header: h, idx }));

    // 结果数组，预先填充为 null
    const result = new Array(n).fill(null);

    // 先把不在 keys 中的列放回它们的原始索引位置
    const keySet = new Set(keys);
    headers.forEach((h, idx) => {
      if (!keySet.has(h.key)) {
        result[idx] = h;
      }
    });

    // 收集 keys 中存在于当前 headers 的列，按 keys 顺序
    const matched = [];
    keys.forEach(k => {
      const m = headerMap.get(k);
      if (m) matched.push(m.header);
    });

    // 把 matched 列按顺序填入 result 中空位（从左到右）
    let mi = 0;
    for (let i = 0; i < result.length && mi < matched.length; i++) {
      if (result[i] === null) {
        result[i] = matched[mi++];
      }
    }

    // 如果还有未放入的 matched（极少见），追加到末尾
    while (mi < matched.length) {
      result.push(matched[mi++]);
    }

    // 返回过滤掉 null 的最终数组
    return result.filter(Boolean);
  }

  //查询方法
  const dataSource = ref([]);
  const tableLoading = ref(false);
  let exportParams = {};//导出用 记录搜索的条件
  const fixedParams = ref({});//用于外部联动搜索 重置不清空
  const search = ({ data = searchformRef.value?.formList || {}, extra = {}, reset = null, current = 1 }) => {
    if (!props?.api?.page) {
      return;
    }
    exportParams = JSON.parse(JSON.stringify({ ...data, ...fixedParams.value}));
    tableLoading.value = true;
    if (current != -1) {
      pagination.current = current;
    }
    const searchData = { current: pagination.current, size: pagination.pageSize, ...data, ...extra, ...fixedParams.value };
    Object.keys(searchData).map(key => {
      !searchData[key] && searchData[key] !== 0 && (delete searchData[key]);//删除空字符串的参数
    });
    props.api.page(searchData).then(res => {
      if (pagination.current != 1 && res.data.records && !res.data.records.length) {//在搜索框输入内容后 点击翻页 导致出现 例如只有第一页有数据 当前在第二页 出现空白
        search({});
        return;
      }
      let result = res.data;
      if(props.changeSearchData){
        result = props.changeSearchData(res.data);
      }
      emits('afterSearch', { data: result, param: { ...data, ...extra, ...fixedParams.value } });
      if (result && result.records) {
        hasPagination.value = true;
        dataSource.value = result.records;
        pagination.total = result.total * 1;
      } else if (Array.isArray(result)) {
        hasPagination.value = false;
        dataSource.value = result;
        pagination.total = result.length;
      }
    }).catch((err) => {
      message.error(err?.msg || `获取数据失败，请稍后重试`);
    }).finally(() => {
      tableLoading.value = false;
      reset && reset(false);
    });
  };
  //分页参数
  let goPageOne = false;
  const hasPagination = ref(true);
  const pagination = reactive({
    current: 1,
    pageSize: attrs.pageSize || 10,
    total: 0,
    showTotal: (total) => `共${total}条记录`,
    showSizeChanger: true,
    showQuickJumper: true,
    onChange: (current, pageSize) => {
      //console.log('change', current, pageSize);
      if (!goPageOne) {
        pagination.current = current;
      } else {
        goPageOne = false;
        pagination.current = 1;
      }
      pagination.pageSize = pageSize;
      search({ current: pagination.current });
    },
    onShowSizeChange: (current, pageSize) => {
      //console.log('showSizeChange', current, pageSize);
      goPageOne = true;
      pagination.pageSize = pageSize;
    },
    ...(attrs.paginationConfig || {}),
  });
  //表格勾选列
  const selectedRowKeys = ref([]);
  const selectedRows = ref([]);
  const actionLoadingKeys = ref(new Set());
  const isActionLoading = (actionKey) => actionLoadingKeys.value.has(String(actionKey));
  const runAction = async (actionKey, request) => {
    const key = String(actionKey);
    if (isActionLoading(key)) return;
    actionLoadingKeys.value = new Set(actionLoadingKeys.value).add(key);
    try {
      return await request();
    } finally {
      const nextLoadingKeys = new Set(actionLoadingKeys.value);
      nextLoadingKeys.delete(key);
      actionLoadingKeys.value = nextLoadingKeys;
    }
  };
  const onSelectRow = (keys, rows) => {
    if (!attrs.rowSelectRadio) {
      selectedRows.value = rows;
      selectedRowKeys.value = keys;
    }
  };
  const rowSelect = record => {
    if (!attrs.rowSelectRadio) {
      return;
    }
    if (selectedRowKeys.value[0] != record[props.rowKey]) {
      selectedRows.value = [record];
      selectedRowKeys.value = [record[props.rowKey]];
    } else {
      selectedRows.value = [];
      selectedRowKeys.value = [];
    }
  };
  const setSelectedRows = (keys = [], rows = []) => {
    selectedRowKeys.value = keys;
    selectedRows.value = rows;
  };
  const clearSelectedRows = () => {
    setSelectedRows([], []);
  };

  //删除方法
  const deleteFun = (record) => {
    const params = {};
    params[props.rowKey] = record[props.rowKey];
    Modal.confirm({
      title: '提示',
      content: props.api.deleteContent || '确认删除！',
      okType: 'danger primary',
      onOk() {
        return props.api.batchDelete(params).then(res => {
          message.success(props.api.deleteMessage || '删除成功');
          search({ current: dataSource.value.length == selectedRowKeys.value.length ? 1 : pagination.current });
          selectedRowKeys.value = [];
        }).catch(err => {
          message.error(err.errorMsg || err?.msg || `删除失败`);
        });
      },
    });
  };

  watch(() => route.query, (query) => {
    const { supportRefresh, type, title, routeName } = query;
    if (supportRefresh && routeName == pageName.value) {
      const data = { ...query };
      delete data.type;
      delete data.title;
      delete data.routeName;
      delete data.supportRefresh;
      nextTick(() => {
        initFormObj({ type, data, title });
      });
    }
  }, { immediate: true });
  const addRouteQuery = ({ type = 'add', data, title = '' } = {}) => {
    const addKey = {};
    if (data) {
      addKey[props.rowKey] = data[props.rowKey];
    }
    let params = {};
    if (props.setUrlParam) {
      params = props.setUrlParam(data || {}) || {};
    }
    const _time = new Date().getTime();
    if (props.target == '_blank') {
      window.open(appendParamsToCurrentUrl({ type, title, ...addKey, routeName: route.name, supportRefresh: 1, _time, ...params }), '_blank');
    } else {
      router.push({
        path: route.path,
        query: {
          ...route.query,
          type,
          title,
          ...addKey,
          routeName: route.name,
          supportRefresh: 1,
          _time,
          ...params
        }
      });
    }
  }

  /**
   * 获取当前URL并拼接参数
   * @param {Object} params - 要拼接的参数对象
   * @returns {string} 拼接后的完整URL
   */
  const appendParamsToCurrentUrl = (params) => {
    // 获取当前URL（不包括哈希部分）
    const currentUrl = window.location.href.split('#')[0];

    // 创建URL对象便于操作
    const url = new URL(currentUrl);

    // 添加新参数
    Object.keys(params).forEach(key => {
      url.searchParams.set(key, params[key]);
    });

    // 返回完整的URL字符串
    return url.toString();
  }

  //初始化表单
  const visibleForm = ref(false);
  const spinningForm = ref(false);
  const FormTitle = ref('新增');
  const form = ref(props.form);
  const openType = ref('');
  const submitFun = ref(null);
  const modalWidth = computed(() => {
    if (props.modalWidth) {
      return props.modalWidth;
    }
    return { drawer: 700, modal: 700, page: 900 }[props.modalType];
  });
  const formStyle = computed(() => {
    if (props.modalType == 'page') {
      return { maxWidth: '100%' }; //`${modalWidth.value}px`
    }
    return { };
  })
  const initForm = (type = 'add', record = {}, fun = null, detailFun = props.api?.pageByID, title = '', formList = null, afterSubmit, autoSearch = true) => {
    submitFun.value = fun;
    if (formList) {
      form.value = formList;
    } else if (type == 'preview' && props.previewForm) {
      form.value = props.previewForm;
    } else if (type == 'approval' && props.approvalForm) {
      form.value = props.approvalForm;
    } else {
      form.value = props.form;
    }
    openType.value = type;
    visibleForm.value = true;
    spinningForm.value = true;
    const extend = { afterSubmit, autoSearch };
    nextTick(() => {
      (props.onBeforeFormInit({ data: record, type }) || Promise.resolve()).then(() => {
        let updateButtonLabel = type == 'update' && props.api.updateButtonLabel ? props.api.updateButtonLabel : undefined;
        FormTitle.value = title || updateButtonLabel || { add: '新增', update: '编辑', preview: '查看', approval: '审批' }[type];
        if (detailFun && (type == 'update' || type == 'preview' || type == 'approval')) {
          detailFun(record).then(res => {
            nextTick(() => {
              emits('formInit', { type, data: res.data, title });
              formRef.value.initData(res.data, type, extend);
              emits('afterFormInit', { type, show: formRef.value.show, disabled: formRef.value.disabled, data: formRef.value.formList, title, record });
              spinningForm.value = false;
            });
          }).catch((err) => {
            message.error(err?.msg || `获取数据失败，请稍后重试`);
            search({ current: -1 });
            visibleForm.value = false;
            spinningForm.value = false;
            if (props.modalType == 'page') {
              router.go(-1);
            }
          });
        } else {
          nextTick(() => {
            emits('formInit', { type, data: record, title });
            const cloneData = JSON.parse(JSON.stringify(record));//防止元数据被改变
            formRef.value.initData(cloneData, type, extend);
            emits('afterFormInit', { type, show: formRef.value.show, disabled: formRef.value.disabled, data: formRef.value.formList, title });
            spinningForm.value = false;
          });
        }
      }).catch(() => {
        visibleForm.value = false;
        spinningForm.value = false;
        if (props.modalType == 'page') {
          router.go(-1);
        }
      });
    });
  };
  const initFormObj = (...arg) => {
    if (typeof arg[0] == 'object') {
      let param = arg[0];
      initForm(param.type, param.data, param.fun, param.detailFun, param.title, param.formList, param.afterSubmit, param.autoSearch);
    } else {
      initForm(...arg);
    }
  }
  //表单点击遮罩层或左上角叉或取消按钮的回调
  const formClose = e => {
    visibleForm.value = true;
    const cloneData = JSON.parse(JSON.stringify(formRef.value?.formList));//防止提交失败 但是元数据已被改变
    (props.onBeforeFormClose({ type: openType.value, data: cloneData, title: FormTitle.value }) || Promise.resolve()).then(res => {
      visibleForm.value = res === false;
    });
  }

  //新增 编辑 等
  const submit = ({ data, type, reset, afterSubmit, autoSearch }) => {
    type = type || openType.value;
    const cloneData = JSON.parse(JSON.stringify(data));//防止提交失败 但是元数据已被改变
    (props.onBeforeSubmit({ type, data: cloneData }) || Promise.resolve(cloneData)).then(newData => {
      const fun = submitFun.value || { add: props.api.save, update: props.api.update, approval: props.api.approval, draft: props.api.draft }[type];
      fun(newData || cloneData).then(res => {
        setTimeout(() => { visibleForm.value = false; }, 100);
        setTimeout(() => { reset && reset(); }, 500);
        if (props.target == '_blank') {
          const newQuery = { ...route.query };
          delete newQuery.type;
          delete newQuery.title;
          delete newQuery[props.rowKey];
          delete newQuery.supportRefresh;
          delete newQuery.routeName;
          delete newQuery._time; 

          router.replace({
            path: route.path,
            query: newQuery
          });
        } else if (route.query.supportRefresh) {
          router.go(-1);
        }

        if (afterSubmit && typeof afterSubmit == 'function') {
          message.success(`${type == 'draft' ? '保存' : FormTitle.value}成功`);
          afterSubmit({ search, openType: openType.value, data: res.data });
        } else if (props.onAfterSubmit && typeof props.onAfterSubmit == 'function') {
          let interceptDefault = props.onAfterSubmit({ search, openType: openType.value, data: res.data });
          if (!interceptDefault) {
            message.success(`${type == 'draft' ? '保存' : FormTitle.value}成功`);
          }
          autoSearch && search({});
        } else {
          message.success(`${type == 'draft' ? '保存' : FormTitle.value}成功`);
          emits('afterSubmit', openType.value);
          autoSearch && search({});
        }
      }).catch(err => {
        message.error(err?.msg || err?.errorMsg ||`${type == 'draft' ? '保存' : FormTitle.value}失败`);
        if (err.code === 2001 || err.code === 2002) {
          props.onSubmitError && props.onSubmitError({ data: formRef.value.formList, errorData: err.data });
        }
        reset && reset(false);
      });
    }).catch((e) => {
      // console.log('onBeforeSubmit:catch');
      // console.log(e);
      reset(false);
    });
  };
  //导出
  const visibleExport = ref(false);
  const exportFormRef = ref();
  const exportFun = ({ data, type, reset }) => {
    Modal.confirm({
      title: '提示',
      content: `将导出已查询出的数据！`,
      onOk() {
        return props.api.export(exportParams).then(res => {
          if (res.headers['content-disposition']) {
            message.success(`导出成功`);
            //获取文件名称与文件类型
            const filename = decodeURI(res.headers['content-disposition'].split('filename=')[1].split('.')[0]);
            const contentType = res.headers['content-type'];
            const url = window.URL.createObjectURL(new Blob([res.data], {
              type: contentType
            }));
            const link = document.createElement('a');
            link.style.display = "none";
            link.download = filename;
            link.href = url;
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          } else {
            const reader = new FileReader()
            reader.onload = async () => {
              const err = JSON.parse(reader.result);
              message.error(err?.msg || `导出失败`);
            }
            reader.readAsText(res.data);
          }
        }).catch(err => {
          message.error(err?.msg || `导出失败`);
        });
      }
    });
  };
  //导入
  const visibleImport = ref(false);
  const spinningImport = ref(false);//加载数据loading
  const importLoading = ref(false);//提交按钮的loading
  const downloadingImportTemplate = ref(false);
  const importData = ref({ successList: [], errorList: [] });
  const importFile = ref(null);
  const importTitle = ref('导入');
  const importApiCache = ref(null);
  watch(visibleImport, (v) => {
    if (v) {
      importData.value = { successList: [], errorList: [] };
      return;
    }
    if (importApiCache.value) {
      Object.assign(props.api, importApiCache.value);
      importApiCache.value = null;
    }
  })
  const importPreview = (e) => {
    //console.log(e.target.files[0]);
    const formData = new FormData();
    formData.append('file', e.target.files[0]);
    spinningImport.value = true;
    props.api.importPreview(formData).then(res => {
      importData.value = res.data;
    }).catch(err => {
      message.error(err?.msg || `导入失败`);
      importData.value = [];
    }).finally(() => {
      importFile.value.value = '';
      spinningImport.value = false;
    });
  }
  const importFun = () => {
    if (!importData.value.successList?.length) {
      message.error(`无可导入数据`);
      return;
    }
    importLoading.value = true;
    // 不同业务导入接口的列表字段名不完全一致，默认兼容原商品批量导入字段。
    const importListField = props.api.importListField || 'commodityBatchImportList';
    props.api.import({ [importListField]: importData.value.successList }).then(res => {
      visibleImport.value = false;
      message.success(`导入成功`);
      searchformRef.value.resetData();
      search({});
    }).catch(err => {
      message.error(err?.msg || `导入失败`);
    }).finally(() => {
      importLoading.value = false;
    });
  }

  //下载导入模板
  const downloadImportTemplate = () => {
    if (downloadingImportTemplate.value) return;
    downloadingImportTemplate.value = true;
    return props.api.importTemplate().then(res => {
      if (res.headers['content-disposition']) {
        message.success(`下载模板成功`);
        //获取文件名称与文件类型
        const filename = decodeURI(res.headers['content-disposition'].split('filename=')[1].split('.')[0]);
        const contentType = res.headers['content-type'];
        const url = window.URL.createObjectURL(new Blob([res.data], {
          type: contentType
        }));
        const link = document.createElement('a');
        link.style.display = "none";
        link.download = filename;
        link.href = url;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        const reader = new FileReader()
        reader.onload = async () => {
          const err = JSON.parse(reader.result);
          message.error(err?.msg || `下载模板失败`);
        }
        reader.readAsText(res.data);
      }
    }).catch(err => {
      message.error(err?.msg || `下载模板失败`);
    }).finally(() => {
      downloadingImportTemplate.value = false;
    });
  }

  const openImportModal = (data) => {
    importApiCache.value = {
      import: props.api.import,
      importPreview: props.api.importPreview,
      importTemplate: props.api.importTemplate,
      importListField: props.api.importListField,
    };
    props.api.import = data.import;
    props.api.importPreview = data.importPreview;
    props.api.importTemplate = data.importTemplate;
    props.api.importListField = data.importListField;
    importTitle.value = data.title || '导入';
    visibleImport.value = true;
  }

  // quick 用于“一键拆单”等确认后直接调接口的按钮。
  const quickLoading = ref(false);
  const quick = ({ data = {}, msg = '操作', type = 'update', fun, okType }, callback) => {
    Modal.confirm({
      title: '提示',
      content: `确认${msg}！`,
      okType: okType || 'primary',
      onOk() {
        quickLoading.value = true;
        return (fun || { add: props.api.save, update: props.api.update }[type])(data).then(res => {
          if (callback) {
            callback(true);
          } else {
            message.success(`${msg}成功`);
            search({ current: pagination.current });
          }
        }).catch((err) => {
          message.error(err && err.msg ? err.msg : `${msg}失败`);
        }).finally(() => {
          quickLoading.value = false;
        });
      },
      onCancel() {
        if (callback) {
          callback(false);
        } else {
          search({ current: pagination.current });
        }
      }
    });
  }

  //向父级抛出的属性 方法
  defineExpose({
    search,
    selectedRowKeys,//表格勾选的id集合
    selectedRows,//表格勾选的行集合
    quickLoading,
    runAction,
    isActionLoading,
    setSelectedRows,
    clearSelectedRows,
    initForm: initFormObj,//手动调用新增和编辑
    addRouteQuery,
    quick,//快捷调用编辑接口 例如启用禁用
    dataSource,//表格数据
    formRef,
    searchformRef,
    fixedParams,
    openImportModal
  });
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .my-list {
    flex: auto;
    width: 100%;
  }
  .searchDiv {
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    padding: 16px 24px 6px 24px;
    border-radius: 8px;
    box-shadow: 0px 2px 4px 0px rgba(81,93,108,0.10); 
  }
  .topBtn {
    display: flex;
    align-items: center;
    min-height: 32px;
    padding: 10px 0;
  }
  .column-setting {
    margin-left: auto;
  }
  .tableDiv {
    background-color: #fff;
    margin-top: 8px;
    padding: 20px 24px 20px 24px;
    border-radius: 8px;
    box-shadow: 0px 2px 4px 0px rgba(81,93,108,0.10);
  }
  .tableDivCenter {
    display: flex;
  }
  .formItemTitle {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    padding: 8px 20px;
    background-color: rgba(24, 144, 255, 0.1);
    margin-right: -30px;
    margin-bottom: 10px;
    font-weight: 600;
    font-size: 18px;
  }

  .columnIcon {
    display: inline-block;
    width: 4px;
    height: 20px;
    border-radius: 3px;
    background-color: #1890ff;
    margin-right: 5px;
  }
  .modalFooter {
    text-align: center;
  }
  .column-list {
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    .action-div {
      display: flex;
      display: -webkit-flex;
      gap: 4px;
      width: 32px;
      align-items: center;
    }
    .action-btn {
      color: #1890ff;
      cursor: pointer;
    }
    .disabled {
      color: #999999;
      cursor: default;
    }
  }
</style>
